/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} P1portal_Group_MoneyInputs */



/**
* | output |
* | --- |
* | "Money" |
*
* @param {P1portal_Group_MoneyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const p1portal_group_money = /** @type {((inputs?: P1portal_Group_MoneyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<P1portal_Group_MoneyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Money")
});